
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs.html/[[...slug]]",
      function () {
        return require("private-next-pages/blogs.html/[[...slug]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs.html/[[...slug]]"])
      });
    }
  